var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefits1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1043 48L25.2545 45.1501L36.0941 34.3104L34.6183 32.8346L23.7786 43.6743L20.9288 40.8244L31.7684 29.9847L30.3435 28.5598L19.5038 39.3995L16.6539 36.5496L27.4427 25.659L25.9669 24.2341L15.1272 35.0738L12.2774 32.2239L25.0509 19.3995L35.5852 29.9338L41.3359 24.1832L29.3257 12.173L33.4987 8L50.8015 25.3028L28.1043 48ZM10.6489 30.9008L5 25.2519L22.2519 8L38.4351 24.1832L35.5344 27.084L25 16.5496L10.6489 30.9008Z",
    fill: "#1CCEDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits1);
export default __webpack_public_path__ + "static/media/benefits1.cee26535068c5f9fb1b7cfac73817f44.svg";
export { ForwardRef as ReactComponent };